import { ActionType } from "../../constants/redux";
import { SEND_OTP, LoginState, VERIFY_OTP, CLEAR_TOKEN } from "./type";
import { ActionStatus } from "../../constants/api";
import { get, isEmpty } from "lodash-es";

const initialState: LoginState = {
  VERIFY_OTP_STATUS: ActionStatus.NONE,
  SEND_OTP_STATUS: ActionStatus.NONE,
  phone: "",
  errorMessage: "",
  verificationToken: localStorage.getItem("verificationToken") || "",
};

const LoginReducer = (state = initialState, action: ActionType): LoginState => {
  switch (action.type) {
    case SEND_OTP.name: {
      return {
        ...state,
        SEND_OTP_STATUS: ActionStatus.LOADING,

        phone: action.payload.phone,
        errorMessage: "",
      };
    }
    case SEND_OTP.success: {
      return {
        ...state,
        SEND_OTP_STATUS: ActionStatus.SUCCESS,

        errorMessage: "",
      };
    }
    case SEND_OTP.failure: {
      const status = get(action.payload, "status", 0);
      const responseString = get(action.payload, "response", "{}");
      let response;
      try {
        response = JSON.parse(responseString);
      } catch (error) {
        response = {
          display_message: "Invalid error response format",
          action_message: "Please try again later.",
        };
      }
      const errorMessage = response.error || "An error occurred";

      return {
        ...state,
        SEND_OTP_STATUS: ActionStatus.FAILURE,
        errorMessage: { ...response, status },
      };
    }

    case VERIFY_OTP.name: {
      return {
        ...state,
        VERIFY_OTP_STATUS: ActionStatus.LOADING,
        errorMessage: "",
      };
    }
    case VERIFY_OTP.success: {
      // Get the response object directly, not as a string
      const response = get(action.payload, "response", {});

      // Extract the token directly from the response object
      const token = response.token || "";

      if (token) {
        localStorage.setItem("verificationToken", token);
      } else {
        console.error("Token not found in response:", response);
      }

      return {
        ...state,
        VERIFY_OTP_STATUS: ActionStatus.SUCCESS,
        verificationToken: token,
        errorMessage: "",
      };
    }
    case VERIFY_OTP.failure: {
      const status = get(action.payload, "status", 0);
      const responseString = get(action.payload, "response", "{}");
      let response;
      try {
        response = JSON.parse(responseString);
      } catch (error) {
        response = {
          display_message: "Invalid error response format",
          action_message: "Please try again later.",
        };
      }
      const errorMessage = response.error || "An error occurred";

      return {
        ...state,
        VERIFY_OTP_STATUS: ActionStatus.FAILURE,
        errorMessage: { ...response, status },
      };
    }
    case CLEAR_TOKEN.name: {
      localStorage.removeItem("verificationToken");
      localStorage.removeItem("otpAuthenticated");
      localStorage.removeItem("onlineRecordCount");
      localStorage.removeItem("offlineRecordCount");

      return {
        ...state,
        verificationToken: "",
        VERIFY_OTP_STATUS: ActionStatus.NONE,
        SEND_OTP_STATUS: ActionStatus.NONE,
        phone: "",
        errorMessage: "",
      };
    }
    default:
      return state;
  }
};

export default LoginReducer;
